<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div v-click-outside="() => open = false">
  <label id="listbox-label" class="sr-only"> Add a Valet </label>
  <div class="mt-1 relative">
    <button @click="open = !open" type="button" class="bg-zinc-50 relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
    <span class="block truncate" v-if="valet && options[valet.id]">
    {{ options[valet.id].name }} - {{ $filters.money(options[valet.id].price) }}
</span>
        <span class="block truncate" v-else>
    Select a valet
</span>

      <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <!-- Heroicon name: solid/selector -->
        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </span>
    </button>

    <!--
      Select popover, show/hide based on select state.

      Entering: ""
        From: ""
        To: ""
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <ul v-show="open" :class="position" class="origin-top-right z-10 left-0 w-full mt-2 rounded-md shadow-lg overflow-hidden bg-white divide-y divide-gray-200 ring-1 ring-black ring-opacity-5 focus:outline-none" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-0">
      <!--
        Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

        Highlighted: "text-white bg-indigo-500", Not Highlighted: "text-gray-900"
      -->
      <li @click="$emit('update:valet', null)" :class="valet == null ? 'text-white bg-ap-fs-primary' : 'text-gray-900'" class="cursor-default select-none relative p-4 text-sm" id="listbox-option-0" role="option">
          <div class="flex flex-col">
          <div class="flex justify-between">
            <p :class="valet == null ? 'font-semibold' : 'font-normal'">No Valet</p>
            <!--
              Checkmark, only display for selected option.
            -->
            <span v-show="valet == null" class="text-white">
              <!-- Heroicon name: solid/check -->
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
          </div>

        </div>
        </li>
      <li  v-for="option in options" :key="option.name" @click="$emit('update:valet', option)" :class="valet?.id == option.id ? 'text-white bg-ap-fs-primary' : 'text-gray-900'" class="cursor-default select-none relative p-4 text-sm" id="listbox-option-0" role="option">
        <div class="flex flex-col">
          <div class="flex justify-between">
            <p :class="valet?.name == option.name ? 'font-semibold' : 'font-normal'">{{ option.name }} - {{ $filters.money(option.price) }}</p>
            <!--
              Checkmark, only display for selected option.
            -->
            <span v-show="valet?.name == option.name" class="text-white">
              <!-- Heroicon name: solid/check -->
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
          </div>
          <p class="mt-2">{{ option.description }}</p>

        </div>
      </li>
    </ul>
  </div>
</div>

</template>

<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    props: {
        options: { type: Array },
        valet: { default: {} },
        position: { default: 'absolute' },
    },
    watch: {
        valet() {
            this.open = false;
        },
    },
};
</script>

<style>

</style>
